@if (userId || editMode) {
    <div class="mt-3">
        <form name="userSetupForm" (ngSubmit)="saveUser()">
            <div class="buttons text-end">
                <!-- button to show form -->
                @if (canEdit && !editMode && !isLoading) {
                    <button type="button" class="ace-btn has-icon btn-primary" (click)="editUser()">
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                <!-- buttons to submit / cancel form -->
                @if (editMode || isLoading) {
                    <span>
                        <button
                            type="submit"
                            class="ace-btn has-icon btn-primary"
                            [disabled]="isLoading || invalid || !userToEdit.userName"
                        >
                            <i class="fa fa-save"></i>
                        </button>
                        <button
                            type="button"
                            class="ace-btn has-icon btn-primary btn-danger"
                            [disabled]="isLoading"
                            (click)="cancelEdit()"
                        >
                            <i class="fa fa-close"></i>
                        </button>
                    </span>
                }
                <button
                    type="button"
                    class="ace-btn btn-primary has-icon"
                    (click)="showDescriptionDialog()"
                    [disabled]="isLoading"
                >
                    @if (userToEdit?.description) {
                        <i class="fa fa-commenting"></i>
                    }
                    @if (!userToEdit?.description) {
                        <i class="fa fa-comment-o"></i>
                    }
                </button>
            </div>
            @if (!isLoading) {
                <div>
                    <!--PT-629 Temporary workaround so non-admin users can still follow the "create, setup, then email" flow -->
                    @if (!canEditUserInfo) {
                        <div class="row">
                            <div class="col-lg-12">
                                @if (
                                    editMode &&
                                    canResetPassword &&
                                    !contact.isMigrated &&
                                    !(userToEdit.ssoDomain || configuringSSO)
                                ) {
                                    <div>
                                        <span class="editable">
                                            <button
                                                type="button"
                                                class="ace-btn btn-sm btn-primary"
                                                title="Create a new random password and email it to the user"
                                                [disabled]="!userId"
                                                (click)="emailPasswordReset(userToEdit.userName)"
                                            >
                                                Email New Password
                                            </button>
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    @if (canEditUserInfo) {
                        <div class="row">
                            <div class="col-lg-6">
                                <div>
                                    <span class="title">User Name: </span>
                                    @if (!editMode) {
                                        <span>{{ userToEdit.userName }}</span>
                                    } @else {
                                        <input
                                            [(ngModel)]="userToEdit.userName"
                                            type="text"
                                            style="margin-bottom: 5px"
                                            class="form-control input-sm"
                                            name="userName"
                                            required
                                            maxlength="50"
                                            (ngModelChange)="checkForSpaces($event)"
                                            [disabled]="!inSupportInstance"
                                        />
                                        @if (invalid) {
                                            <span class="text-danger">User name cannot contain spaces.</span>
                                        }
                                    }
                                    @if (showLoginManager) {
                                        <span>
                                            <a
                                                (click)="goToLoginManager()"
                                                anchor-route
                                                [sref]="{ target: 'loginManager', options: { userId: userId } }"
                                                style="display: inline-block; padding-top: 5px; padding-left: 10px"
                                                >Manage Login</a
                                            >
                                        </span>
                                    }
                                </div>
                                <div>
                                    <span class="title">IAM: </span>
                                    <span style="padding-top: 5px; display: inline-block">{{
                                        iamMigrationStatus
                                    }}</span>
                                </div>
                                @if (userToEdit.ssoDomain || (!userId && ssoDomains && ssoDomains.length >= 1)) {
                                    <div>
                                        <span class="title">SSO Domain: </span>
                                        @if (!editMode) {
                                            <span class="editable">{{ userToEdit.ssoDomain }}</span>
                                        } @else {
                                            <ws-select
                                                [(ngModel)]="userToEdit.ssoDomain"
                                                name="ssoDomain"
                                                [options]="ssoDomains"
                                                [isPrimitive]="true"
                                                [disabled]="isLoading || !canEditUserInfo"
                                            >
                                            </ws-select>
                                        }
                                    </div>
                                }
                                @if (editMode && configuringSSO) {
                                    <div>
                                        <span class="title">SSO Domain: </span>
                                        @if (editMode) {
                                            <ws-select
                                                [(ngModel)]="newSSODomain"
                                                name="newSSODomain"
                                                [options]="newSSODomains"
                                                [isPrimitive]="true"
                                                [disabled]="isLoading || !canEditUserInfo"
                                            >
                                            </ws-select>
                                        }
                                        @if (userId) {
                                            <button
                                                type="button"
                                                class="ace-btn btn-sm btn-primary"
                                                (click)="cancelConfigureSSO()"
                                                [disabled]="isLoading || !canEditUserInfo"
                                            >
                                                Cancel
                                            </button>
                                        }
                                    </div>
                                }
                                @if (editMode && canEditUserInfo && !(userToEdit.ssoDomain || configuringSSO)) {
                                    <div>
                                        <span class="title"></span>
                                        <span class="editable">
                                            @if (!contact.isMigrated) {
                                                <button
                                                    type="button"
                                                    class="ace-btn btn-sm btn-primary"
                                                    title="Create a new random password and email it to the user"
                                                    [disabled]="!userId"
                                                    (click)="emailPasswordReset(userToEdit.userName)"
                                                >
                                                    Email New Password
                                                </button>
                                            }
                                            @if (userId || newSSODomains || newSSODomains.length >= 1) {
                                                <button
                                                    type="button"
                                                    class="ace-btn btn-sm btn-primary"
                                                    title="Configure this user to sign in with a Single Sign On (SSO) provider"
                                                    [disabled]="!userId || !canEditUserInfo"
                                                    (click)="configuringSSO = true"
                                                >
                                                    Configure SSO
                                                </button>
                                            }
                                        </span>
                                    </div>
                                }
                            </div>
                            <div class="col-lg-4">
                                <div>
                                    <span class="title">Home instance: </span>
                                    @if (!editMode) {
                                        <span class="normal-text">{{ getHomeInstanceName() }}</span>
                                    } @else {
                                        <ws-select
                                            [(ngModel)]="userToEdit.instanceId"
                                            name="instanceId"
                                            [options]="contactStatuses"
                                            labelProperty="instanceName"
                                            valueProperty="instanceId"
                                            [disabled]="isLoading || !canEditUserInfo"
                                        >
                                        </ws-select>
                                    }
                                </div>
                            </div>
                            @if (showActiveCheckbox) {
                                <div class="col-lg-2">
                                    <div>
                                        @if (!editMode && userToEdit.active) {
                                            <span>Active</span>
                                        }
                                        @if (editMode) {
                                            <div class="checkbox" style="margin-top: 0; margin-bottom: 5px">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        [(ngModel)]="userToEdit.active"
                                                        name="active"
                                                        [disabled]="!canEditUserInfo"
                                                    />
                                                    Active
                                                </label>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </form>
        @if (userToEdit) {
            <div class="row" style="margin-top: 20px">
                <div class="col-lg-6">
                    <user-group-panel
                        [instanceId]="instanceId"
                        [(assignedGroups)]="userToEdit.userToGroup"
                        [canEdit]="editMode"
                    >
                    </user-group-panel>
                </div>
                <div class="col-lg-6">
                    @if (!isLicensedUser) {
                        <user-application-permission-panel
                            [assignedPermissions]="userToEdit.roles"
                            [editMode]="editMode"
                            [userSetup]="true"
                        >
                        </user-application-permission-panel>
                    }
                    <user-instance-permission-panel
                        [instanceId]="instanceId"
                        [assignedPermissions]="userToEdit.instancePermissions"
                        [permissionsLookup]="permissionsLookup"
                        [availablePermissions]="availableInstanceRights"
                        [editMode]="editMode"
                        [userSetup]="true"
                    >
                    </user-instance-permission-panel>
                </div>
            </div>
        }
        @if (userToEdit && userToEdit.id && tabSelected) {
            <div class="row">
                <div class="col-lg-12">
                    <company-permission-user-panel
                        [userToEdit]="userToEdit"
                        [userId]="userToEdit.id"
                        [editMode]="editMode"
                    >
                    </company-permission-user-panel>
                </div>
            </div>
        }
    </div>
} @else {
    <div class="text-center" style="margin: 50px 200px">
        @if (needTaxDotComPermission) {
            <p class="alert alert-danger">
                You are not authorized to invite a new user to tax.com. Please contact the tax.com support team at
                <a href="mailto:Propertypoint.Support@ryan.com">Propertypoint.Support&#64;ryan.com</a>
            </p>
        }
        @if (!(needTaxDotComPermission || isLoading)) {
            <div>
                <p class="lead"
                    >This contact is not currently a user of PropertyPoint. Click below to create a new user for the
                    contact.</p
                >
                <div>
                    <button class="ace-btn btn-lg btn-primary btn-success" (click)="createUser(false)">
                        Create User
                    </button>
                </div>
                @if (showCreateLegacyUser) {
                    <div style="margin-top: 1em">
                        <button class="ace-btn btn-lg btn-primary btn-success" (click)="createUser(true)">
                            Create Legacy User
                        </button>
                    </div>
                }
            </div>
        }
        @if (isLoading) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
    </div>
}
